import { render, staticRenderFns } from "./TodayOrders.vue?vue&type=template&id=41359824&scoped=true&"
import script from "./TodayOrders.vue?vue&type=script&lang=js&"
export * from "./TodayOrders.vue?vue&type=script&lang=js&"
import style0 from "./TodayOrders.vue?vue&type=style&index=0&id=41359824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41359824",
  null
  
)

export default component.exports